/**
 * Mutation types
 */
export enum SurveySummaryMutationEnum {
  GET_SURVEY_SUMMARIES = 'GET_SURVEY_SUMMARIES',
  GET_SURVEY_SUMMARIES_FULFILLED = 'GET_SURVEY_SUMMARIES_FULFILLED',
  GET_SURVEY_SUMMARIES_REJECTED = 'GET_SURVEY_SUMMARIES_REJECTED'
}
